import { useState } from 'react';
import { Toast } from 'primereact/toast';
import {
  PermissionList,
  PermissionCreateDialog,
  PermissionEditDialog,
} from '@authifi/clique-react-ui';
import type { ResourceServerPermission } from '@authifi/clique-react-ui';
import { useEntityToasts } from '../hooks/useEntityToasts';

export function PermissionsPage() {
  const { toastRef, notifyCreated, notifyUpdated, notifyDeleted } = useEntityToasts('Permission');
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [editingPermission, setEditingPermission] = useState<ResourceServerPermission | null>(null);

  return (
    <div>
      <Toast ref={toastRef} />
      <h2 className="text-2xl font-semibold text-[var(--clique-fg)] mb-2">Permissions</h2>
      <p className="text-[var(--clique-fg-muted)] mb-6">Manage permissions and access controls.</p>

      <PermissionList
        onPermissionSelect={setEditingPermission}
        onCreatePermission={() => setShowCreateDialog(true)}
      />

      <PermissionCreateDialog
        visible={showCreateDialog}
        onHide={() => setShowCreateDialog(false)}
        onCreated={(permission) => notifyCreated(permission.name)}
      />

      <PermissionEditDialog
        visible={editingPermission !== null}
        onHide={() => setEditingPermission(null)}
        permission={editingPermission}
        onUpdated={(permission) => notifyUpdated(permission.name)}
        onDeleted={notifyDeleted}
      />
    </div>
  );
}
